import { inject, Pipe, PipeTransform } from '@angular/core';
import { translate } from '@jsverse/transloco';

import { TimezoneService } from '../services/timezone.service';
import { TimeIntervalUtils } from '../utils/time-interval.utils';

@Pipe({
  name: 'timeInterval',
  pure: true,
  standalone: false,
})
export class TimeIntervalPipe implements PipeTransform {
  weekOfTranslation = translate('widgets.charting.tooltip.date-part-week-of');
  invalidDate = translate('widgets.charting.invalid-date');

  timezoneService = inject(TimezoneService);
  transform(
    value: string,
    type: keyof typeof TimeIntervalUtils.FORMAT_MAP | string = 'month'
  ): string {
    return TimeIntervalUtils.formatTimeInterval(
      value,
      type,
      this.timezoneService.timezone,
      this.weekOfTranslation,
      this.invalidDate
    );
  }
}
